export default __webpack_public_path__ + "static/media/ThumbsUp_Small_FilledBlack.35539cfe.svg";